import React from 'react'
import { useParams } from 'react-router'
import HeaderTabLayout from '../../components/HeaderTabLayout'
import Layout from '../../components/Layout'
import Loader from '../../components/Loader'
import LeadTypeConversionView from '../../components/version-4/viewForms/LeadTypeConversionView'
import { useLeadTypeConversion } from '../../hooks/CompanyConfiguration/useLeadTypeConversion'
import { ROUTES } from '../../shared/constants'

function ViewLeadTypeConversion() {
    const { getLeadTypeConversion, leadTypeConversion } = useLeadTypeConversion()
    const params = useParams()

    React.useEffect(() => {
        getLeadTypeConversion({ convertLeadTypeId: params.convertLeadTypeId })
    }, [params.convertLeadTypeId])

    return (
        <Layout heading="Lead Type Conversion" heading2="Info" url1={ROUTES.LEADTYPE_CONVERSION} none>
            {leadTypeConversion ? (
                <HeaderTabLayout
                    heading="Lead Type Conversion"
                    content={<LeadTypeConversionView leadTypeConversion={leadTypeConversion} />}
                    view
                    url={`/edit-leadtype-conversion/${params.convertLeadTypeId}`}
                />
            ) : <Loader />}
        </Layout>
    )
}

export default ViewLeadTypeConversion
